module.exports = __webpack_public_path__ + "static/media/cards-games-about.eb8d5cf9.jpg";